import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './_styles.scss'

class LayoutOneChannel extends Component {
  render() {
    const { groups = {} } = this.props;

    const poster1 = groups[0] || {};

    return (
      <div className="layout-one-channel">
        <div className='layout-one-channel__poster'>
          <img 
            src={poster1.images.horizontal} 
            alt={poster1.title} 
          />
        </div>
      </div>
    );
  }
}

LayoutOneChannel.propTypes = {
  groups: PropTypes.array,
};

LayoutOneChannel.defaultProps = {
  groups: [],
};

export default LayoutOneChannel;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialChannels/Components/LayoutOneChannel/index.jsx